import React, { useContext, useEffect } from "react";
import { AppContext } from "./index";
import { clBasic } from "./general"

export default function EarnValue() { // funciona git con apple
  let { firebase } = useContext(AppContext);
  let h = window.innerHeight / 2.2
  let w = window.innerWidth / 3
  let color = ["#87FF2A", "#FF7A00", "#5DADEC", "#5858FA", "#FF8000"];

  useEffect(() => {
    let c = document.getElementById("EVgrafico").getContext("2d");
    let { EV, AC, PV, semana, SPI, CPI, minSC, maxSC } = firebase.datosEV(firebase.proyectoActivo.proyecto.id, 8);

    if (EV.length) {
      evg(c, PV[PV.length - 1], EV[EV.length - 1], AC[AC.length - 1], SPI[SPI.length - 1], CPI[CPI.length - 1]);
      eje(c, w, (h * 3) / 4, (h * 1) / 4);
      evGrafico(c, SPI, semana, minSC, maxSC, "SPI", color[3], w, (h * 3) / 4, (h * 1) / 4);
      evGrafico(c, CPI, semana, minSC, maxSC, "CPI", color[4], w, (h * 3) / 4, (h * 1) / 4);
    }
  });

  function evg(c, pv, ev, ac, spi, cpi) { //
    let xCentro = w * 0.9
    let yCentro = h * 0.2
    let pev = Math.trunc(spi * 100);
    let pac = Math.trunc(cpi * 100);
    let factorR = Math.max(spi, cpi, 1);
    let radio = 30

    c.beginPath();
    c.arc(xCentro, yCentro, (radio * cpi) / factorR, 0, 2 * Math.PI, false);
    c.fillStyle = "#FF8000";
    c.fill();
    c.beginPath();
    c.arc(xCentro, yCentro + (radio * cpi) / factorR + (radio) / factorR + 20, radio / factorR, 0, 2 * Math.PI, false);
    c.fillStyle = "gray";
    c.fill();
    c.beginPath();
    c.arc(xCentro, yCentro + (radio * cpi) / factorR + 2 * radio / factorR + 40 + radio * spi / factorR, (radio * spi) / factorR, 0, 2 * Math.PI, false);
    c.fillStyle = "#5858FA";
    c.fill();
    // etiquetas
    c.font = "600 1.3vh Arial";
    c.fillStyle = clBasic;
    c.fillText("Costo", xCentro - c.measureText("Costo").width / 2, yCentro - radio * cpi / factorR - 15);
    let acStr = pac.toString() + "%";
    c.fillText(acStr, xCentro - c.measureText(acStr).width / 2, yCentro);
    c.fillText("Plan", xCentro - c.measureText("Plan").width / 2, yCentro + (radio * cpi) / factorR + (radio) / factorR + 20);
    c.fillText("Cronograma", xCentro - c.measureText("Cronograma").width / 2, yCentro + (radio * cpi) / factorR + 2 * radio / factorR + 60 + 2 * radio * spi / factorR);
    let evStr = pev.toString() + "%";
    c.fillText(evStr, xCentro - c.measureText(evStr).width / 2, yCentro + (radio * cpi) / factorR + 2 * radio / factorR + 40 + radio * spi / factorR);
  }

  function eje(c, X, Y, top) {
    c.beginPath();
    c.moveTo(45, Y);
    c.lineTo(45, top);
    c.strokeStyle = clBasic;
    c.stroke();
  }

  function evGrafico(c, datos, semanas, min, max, titulo, color, X, Y, top) {
    function coordX(x) {
      // el x no es el valor en x sino el indice del array correspondiente al mismo
      return x0 + (x * largo) / semanas.length;
    }
    function coordY(y) {
      return y0 - (alto * (y - min)) / (max - min);
    }

    const largo = X - 140;
    const alto = Y - 40 - top;
    const x0 = 70;
    const y0 = Y - 20;

    // itero sobre los valores
    datos.forEach((d, ind) => {
      c.beginPath();
      c.font = "2.4vh Arial";
      c.fillStyle = clBasic;
      c.fillText("Valor Ganado", 70, 50);
      c.setLineDash([]);
      c.arc(coordX(ind), coordY(d), 5, 0, 2 * Math.PI, false);
      c.fillStyle = color;
      c.fill();
      //
      c.moveTo(coordX(ind), coordY(d));
      if (ind !== datos.length - 1) {
        //no es el ultimo
        c.lineTo(coordX(ind + 1), coordY(datos[ind + 1]));
        c.strokeStyle = color;
        c.stroke();
      }
    });

    c.beginPath();
    c.font = "1.9vh Arial";
    c.fillStyle = clBasic;
    let minT = top ? min.toFixed(2).toString() : min.toString();
    let maxT = top ? max.toFixed(2).toString() : max.toString();
    c.fillText(minT, 5, coordY(min));
    c.fillText(maxT, 5, coordY(max));

    if (top) {
      c.strokeStyle = clBasic;
      c.setLineDash([2, 2]);
      c.moveTo(60, coordY(1));
      c.lineTo(largo + 40, coordY(1));
      c.stroke();
      c.fillText("1", 25, coordY(1));
    }
  }

  return (
    <div style={Scanvas}>
      <canvas id="EVgrafico" height={h} width={w} />
    </div>
  );
}

const Scanvas = {
  position: "relative",
  overflow: "hidden",
};
